import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useStateContext } from "contexts/auth-context";
import { Navigate } from "react-router-dom";
import CustomizedMenuList from "components/Custom/CustomizedMenuList";
import CustomizedBreadcrumbs from "components/Custom/CustomizedBreadcrumbs";

import { IBreadcrumbsAndMenu } from "types/global";

const Logistic = () => {
  const { t } = useTranslation();
  const {
    state: { permissions },
  } = useStateContext();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("logistic.index"),
    },
  ];

  const menuList: IBreadcrumbsAndMenu[] = [
    permissions?.vehicle?.view && {
      name: t("logistic.vehicle.index"),
      to: "/logistic/vehicle",
    },
    permissions?.tire?.view && {
      name: t("logistic.tire.index"),
      to: "/logistic/tire",
    },
    permissions?.delivery_trip?.view && {
      name: t("logistic.delivery_trip.index"),
      to: "/logistic/delivery-trip",
    },
    permissions?.location?.view && {
      name: t(`logistic.location.index`),
      to: "/logistic/location",
    },
    permissions?.logistic_export?.view && {
      name: t("logistic.report.index"),
      to: "/logistic/report",
    },
    permissions?.gantt_chart?.view && {
      name: t("logistic.gantt_chart.index"),
      to: "/logistic/gantt-chart",
    },
  ].filter(Boolean) as IBreadcrumbsAndMenu[];

  if (permissions && !permissions.logistic?.view) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <Fragment>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <CustomizedMenuList menuList={menuList} />
    </Fragment>
  );
};

export default Logistic;
